import { InputNumber, InputNumberProps } from "antd";
import React from "react";
import "./percent-input.scss";

const PercentInput = (props: InputNumberProps) => {

    // const parse = (value: string | undefined) => {
    //     if (value === undefined || value === "" || value === null) {
    //         return "%";
    //     }
    //     return value.replace('%', '')
    // }

    const format = (value: string | number | undefined) => {
        if (value === undefined || value === "") return "";
        return `${value}%`
    }


    return (
        <InputNumber
            {...props}
            className={`percent-input${props.className ? " " + props.className : ""}`}
            formatter={value => format(value)}
            placeholder={props.placeholder || "%"}
            stringMode
        />
    )
}


export default PercentInput;